import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {IVanillaReaderHighlightData} from "../VanillaReader/VanillaReaderModel";
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {VanillaReaderUI} from "./VanillaReaderUI";
import {IVanillaReaderAppEvent_NAVIGATION_INTENT} from '../VanillaReaderEventBus/IVanillaReaderAppEventTypeMap';

export interface VanillaReaderUiDialogHighlightsController extends IVanillaReaderUiComponentController, IVanillaReaderUI {}

/**
* # VanillaReaderUiDialogHighlightsController
*
* ## RESPONSIBILITIES
* This controller mixing class handles all event callbacks from the `VanillaReaderUiDialogHighlights` class.
 *
* Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
* in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
*
* ## RELATED TYPES
* - VanillaReaderUi
* - VanillaReaderUiDialogHighlights
*
* */
export class VanillaReaderUiDialogHighlightsController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.dialogHighlights.onHighlightItemClicked(vanillaReaderUiContext._onDialogHighlightsItemClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogHighlights.onHighlightItemEditButtonClicked(vanillaReaderUiContext._onDialogHighlightsItemEditButtonClicked.bind(vanillaReaderUiContext));
    }

    _onDialogHighlightsItemClicked (navigationData: IVanillaReaderAppEvent_NAVIGATION_INTENT): void {
        if (navigationData.locator) {
            this.navigateTo(navigationData.locator.toString());
        }

        this.dialogHighlights?.close(true, false);
    };

    _onDialogHighlightsItemEditButtonClicked(highlight: IVanillaReaderHighlightData): void {
        // If the highlight dialog was opened from the highlights list, let's close it.
        if (this.activeDialogTitle === 'Highlights') {
            this.dialogHighlights.close(true);
        }

        this.dialogHighlight?.setState(highlight, false);
        this.dialogHighlight?.show();
    };

}
